import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    StyledTableCaption,
    TableRowName,
    TableRowNameTop,
} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    APPLY_IRREGULAR_PATTERN,
    CHANGE_TYPE,
    MESSAGE_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
    USER_ATTRIBUTE,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyButtonTextWithIcon,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    DelegateApprovalButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpDelegateApprovalButton,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import ReactToPrint from 'react-to-print'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import {NatApplicationStatusComponent} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {NatParkingUsesChangeDetail} from '../repository/NatGetParkingUsesChange'
import {NatParkingUseChangeApplicationDocument} from '../common/admin/print/NatParkingUseChangeApplicationDocument'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {
    NatPutRejectionParkingUsesChangeRequest,
    NatPutRejectionParkingUsesChangeResponse,
} from '../repository/NatPutRejectionParkingUsesChangeRequest'
import {
    NatPutApprovalParkingUsesChangeResponse,
    NatPutApprovalsParkingUsesChangeRequest,
} from '../repository/NatPutApprovalsParkingUsesChangeRequest'
import NatAdminApplicationApprovalDelegateDialog from '../common/admin/NatAdminApplicationApprovalDelegateDialog'
import NatAdminApplicationApprovalDirectorDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalDirectorDelegateComponent'
import NatAdminApplicationApprovalDialog from '../common/admin/NatAdminApplicationApprovalDialog'
import {getRandomKey} from '../../../common/util/Natutil'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {formatDate, formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {Check, Close} from '@mui/icons-material'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {NatAdminApplicationCommentToAssocDirector} from '../common/admin/NatAdminApplicationCommentToAssocDirector'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    parkingUsesChangeDetail: NatParkingUsesChangeDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    rejectionComment: string
    receptionComment: string
    approvalComment: string
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    actingChecked: boolean
    residentApplyProcess: RESIDENT_APPLY_PROCESS
}

type DialogContentType = 'reception' | 'rejection' | 'delegate' | 'delegateApproval' | 'delegateRejection' | 'approval'

class NatAdminParkingUsesPageChange extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    applicationRef: RefObject<HTMLDivElement>
    contractRef: RefObject<HTMLDivElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            parkingUsesChangeDetail: {
                applyId: '',
                applyStatus: '',
                condominiumCd: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                useArea: '',
                changeType: '',
                changeStartDate: '',
                changeEndDate: '',
                userFamilyName: '',
                userFirstName: '',
                userAttribute: '',
                ownerFamilyName: '',
                ownerFirstName: '',
                carBodyShape: '',
                carName: '',
                carRegistrationNumber: '',
                engineSize: '',
                length: '',
                height: '',
                width: '',
                vehicleWeight: '',
                vehicleTotalWeight: '',
                version: 0,
            },
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            rejectionComment: '',
            receptionComment: '',
            approvalComment: '',
            actingChecked: true,
            dialogStatus: null,
            isLoadCompleted: false,
            residentApplyProcess: RESIDENT_APPLY_PROCESS.RECEPTION,
        }

        this.ownUrl = this.props.location.pathname
        this.applicationRef = React.createRef()
        this.contractRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleDelegateClick = this.handleDelegateClick.bind(this)
        this.handleDelegateApprovalClick = this.handleDelegateApprovalClick.bind(this)
        this.handleDelegateApprovalOkClick = this.handleDelegateApprovalOkClick.bind(this)
        this.handleDelegateRejectionClick = this.handleDelegateRejectionClick.bind(this)
        this.handleDelegateRejectionOkClick = this.handleDelegateRejectionOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
        this.handleReceptionCommentChange = this.handleReceptionCommentChange.bind(this)
        this.handleApprovalCommentChange = this.handleApprovalCommentChange.bind(this)
        this.onChangeActingChecked = this.onChangeActingChecked.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                    isLoadCompleted: true,
                },
            )
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [parkingUsesChangeResponse, applicationStatusResponse] = await Promise.all([
            this.getParkingUsesChange(),
            this.getApplicationStatus(),
        ])

        if (parkingUsesChangeResponse && applicationStatusResponse) {
            const residentApplyProcess: RESIDENT_APPLY_PROCESS =
                parkingUsesChangeResponse.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value
                    ? RESIDENT_APPLY_PROCESS.RECEPTION : RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL
            this.setState({
                parkingUsesChangeDetail: parkingUsesChangeResponse,
                applicationStatusDetail: applicationStatusResponse,
                residentApplyProcess: residentApplyProcess,
            })
        }
    }

    async getParkingUsesChange(): Promise<Nullable<NatParkingUsesChangeDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getParkingUsesChange.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    handleDialogCancelClick(): void {
        this.setState({dialogStatus: null, actingChecked: true, receptionComment: '', approvalComment: ''})
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleApprovalClick(): void {
        this.setState({dialogStatus: 'approval'})
    }

    handleDelegateClick(): void {
        this.setState({dialogStatus: 'delegate'})
    }

    handleDelegateApprovalClick(): void {
        this.setState({dialogStatus: 'delegateApproval'})
    }

    handleDelegateRejectionClick(): void {
        this.setState({dialogStatus: 'delegateRejection'})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    handleReceptionCommentChange(value: string): void {
        this.setState({receptionComment: value})
    }

    handleApprovalCommentChange(value: string): void {
        this.setState({approvalComment: value})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, parkingUsesChangeDetail, residentApplyProcess} = this.state

        const assocFlag = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionParkingUsesChangeRequest = {
                operation: residentApplyProcess.value,
                comment: rejectionComment,
                version: parkingUsesChangeDetail.version,
            }

            const response: Nullable<NatPutRejectionParkingUsesChangeResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionParkingUsesChange
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                if (!assocFlag) {
                    this.props.navigate(`${this.ownUrl}`, {
                        replace: true,
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0004.toString('申請'),
                            },
                            refreshToken: getRandomKey(),
                        },
                    })
                } else {
                    this.props.navigate('/admin/applications', {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0006.toString(
                                    '申請',
                                    this.state.parkingUsesChangeDetail.applyId,
                                    APPLY_CATEGORY.CAR_CHANGE.label),
                            },
                        },
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {receptionComment, parkingUsesChangeDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsParkingUsesChangeRequest = {
                operation: residentApplyProcess.value,
                comment: receptionComment,
                version: parkingUsesChangeDetail.version,
            }

            const response: Nullable<NatPutApprovalParkingUsesChangeResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalParkingUsesChange
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, parkingUsesChangeDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsParkingUsesChangeRequest = {
                operation: residentApplyProcess.value,
                comment: approvalComment,
                version: parkingUsesChangeDetail.version,
            }

            const response: Nullable<NatPutApprovalParkingUsesChangeResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalParkingUsesChange
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/applications', {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0005.toString(
                                '申請',
                                this.state.parkingUsesChangeDetail.applyId,
                                APPLY_CATEGORY.CAR_CHANGE.label),
                        },
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, parkingUsesChangeDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsParkingUsesChangeRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: approvalComment,
                version: parkingUsesChangeDetail.version,
            }

            const response: Nullable<NatPutApprovalParkingUsesChangeResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalParkingUsesChange
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, parkingUsesChangeDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionParkingUsesChangeRequest = {
                operation: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: rejectionComment,
                version: parkingUsesChangeDetail.version,
            }

            const response: Nullable<NatPutRejectionParkingUsesChangeResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionParkingUsesChange
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeActingChecked(checked: boolean): void {
        this.setState({actingChecked: !checked})
    }

    renderDetailsTable(): ReactNode {
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            useArea,
            changeType,
            userFamilyName,
            userFirstName,
            userAttribute,
            ownerFamilyName,
            ownerFirstName,
            carBodyShape,
            carName,
            carRegistrationNumber,
            engineSize,
            length,
            height,
            width,
            vehicleWeight,
            vehicleTotalWeight,
        } = this.state.parkingUsesChangeDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.CAR_CHANGE.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>使用区画</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {useArea}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>変更態様</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {CHANGE_TYPE.codeToEnumConstants(changeType).label}
                            </StyledTableCell>
                        </TableRow>
                        {this.renderChangeDate()}
                        <TableRow>
                            <TableRowName>使用者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {userFamilyName} {userFirstName}
                                （{USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label}）
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={8}>変更後の車両情報</TableRowNameTop>
                            <SecondaryTableRowName>
                                所有者
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {ownerFamilyName} {ownerFirstName}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                形状
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {carBodyShape}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                車名
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {carName}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                自動車登録番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {carRegistrationNumber}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                排気量
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {engineSize}L
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                外寸（長さ/高さ/幅）
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {length + 'cm/' + height + 'cm/' + width + 'cm'}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                車両重量
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {vehicleWeight}kg
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                車両総重量
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {vehicleTotalWeight}kg
                            </SecondaryTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderChangeDate(): ReactNode {
        const {
            changeType,
            changeStartDate,
            changeEndDate,
        } = this.state.parkingUsesChangeDetail

        if (changeType === CHANGE_TYPE.TEMPORARY.value) {
            return (
                <>
                    <TableRow>
                        <TableRowNameTop rowSpan={2}>変更日</TableRowNameTop>
                        <SecondaryTableRowName>
                            開始日
                        </SecondaryTableRowName>
                        <SecondaryTableCell colSpan={3}>
                            {moment(changeStartDate).format('YYYY年M月D日')}
                        </SecondaryTableCell>
                    </TableRow>
                    <TableRow>
                        <SecondaryTableRowName end>
                            終了日
                        </SecondaryTableRowName>
                        <SecondaryTableCell colSpan={3} end>
                            {moment(changeEndDate).format('YYYY年M月D日')}
                        </SecondaryTableCell>
                    </TableRow>
                </>
            )
        } else {
            return (
                <>
                    <TableRow>
                        <TableRowNameTop rowSpan={1}>変更日</TableRowNameTop>
                        <SecondaryTableRowName end>
                            開始日
                        </SecondaryTableRowName>
                        <SecondaryTableCell colSpan={3} end>
                            {moment(changeStartDate).format('YYYY年M月D日')}
                        </SecondaryTableCell>
                    </TableRow>
                </>
            )
        }
    }


    renderPageHeaderArea(): ReactNode {
        const {parkingUsesChangeDetail} = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'10px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.applicationRef.current}/>
                        <PrintContentArea>
                            <div ref={this.applicationRef}>
                                <NatParkingUseChangeApplicationDocument
                                    parkingUseChangeApplicationDocumentParam={parkingUsesChangeDetail}
                                    applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                />
                            </div>
                        </PrintContentArea>
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {parkingUsesChangeDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(parkingUsesChangeDetail.applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(parkingUsesChangeDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderPc(): ReactNode {
        return (
            <>
                <Box mb={'20px'}>
                    {this.renderPageHeaderArea()}
                </Box>
                <PageMainArea>
                    {this.renderDetailsTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.parkingUsesChangeDetail.applyStatus}
                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    renderSpApplicantInfo(): ReactNode {
        const {parkingUsesChangeDetail} = this.state
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            applyStatus,
        } = parkingUsesChangeDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    <div>{applyId}</div>
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.CAR_CHANGE.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            <ReactToPrint
                                trigger={() => (
                                    <PrintLink>
                                        <Box ml={'10px'}>
                                            印刷する
                                        </Box>
                                    </PrintLink>
                                )}
                                content={() => this.applicationRef.current}/>
                            <PrintContentArea>
                                <div ref={this.applicationRef}>
                                    <NatParkingUseChangeApplicationDocument
                                        parkingUseChangeApplicationDocumentParam={parkingUsesChangeDetail}
                                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                    />
                                </div>
                            </PrintContentArea>
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box pt={'12px'} pb={'12px'}>
                        <div>{condominiumName}</div>
                        <div>{applicant}</div>
                    </Box>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSpCommentToAssocDirector(): ReactNode {
        const {parkingUsesChangeDetail, applicationStatusDetail} = this.state
        if (parkingUsesChangeDetail.applyStatus !== RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) {
            return null
        }

        const commentToAssocDirectorInfo = applicationStatusDetail.applyStatusInfo
            .find(status => status.applyProcess === RESIDENT_APPLY_PROCESS.RECEPTION.value)
            ?.actual

        if (!(commentToAssocDirectorInfo?.comment)) {
            return null
        }

        return <Box pb={'16px'}>
            <NatAdminApplicationCommentToAssocDirector
                comment={commentToAssocDirectorInfo.comment}
                roleId={commentToAssocDirectorInfo.roleId}
                familyName={commentToAssocDirectorInfo.familyName}
                firstName={commentToAssocDirectorInfo.firstName}
                registerDatetime={commentToAssocDirectorInfo.registerDatetime}
            />
        </Box>
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            useArea,
            changeType,
            changeStartDate,
            changeEndDate,
            userFamilyName,
            userFirstName,
            userAttribute,
            ownerFamilyName,
            ownerFirstName,
            carBodyShape,
            carName,
            carRegistrationNumber,
            engineSize,
            length,
            height,
            width,
            vehicleWeight,
            vehicleTotalWeight,
            applyStatus,
        } = this.state.parkingUsesChangeDetail

        return (
            <>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>使用区画</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {useArea}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>変更態様</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {CHANGE_TYPE.codeToEnumConstants(changeType).label}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>変更日</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        開始日：{formatDate(changeStartDate)}
                    </SpApplicationDetailInfoContentValue>
                    {(changeType === CHANGE_TYPE.TEMPORARY.value) &&
                        <SpApplicationDetailInfoContentValue>
                            終了日：{formatDate(changeEndDate)}
                        </SpApplicationDetailInfoContentValue>
                    }
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>使用者</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {userFamilyName} {userFirstName}（{USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label}）
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>変更後の車両情報</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        所有者：{ownerFamilyName} {ownerFirstName}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        形状：{carBodyShape}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        車名：{carName}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        自動車登録番号：{carRegistrationNumber}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        排気量：{engineSize}L
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        外寸（長さ/高さ/幅）：{length + 'cm/' + height + 'cm/' + width + 'cm'}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        車両重量：{vehicleWeight}kg
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        車両総重量：{vehicleTotalWeight}kg
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {(applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><ApplyButtonTextWithIcon>受け付ける</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
            </>
        )
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (
            <NatApplicationStatusComponent
                currentApplyStatus={this.state.parkingUsesChangeDetail.applyStatus}
                applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
            />
        )
    }

    renderSp(): ReactNode {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {this.renderSpApplicantInfo()}
                <Box height={'16px'}/>
                {this.renderSpCommentToAssocDirector()}
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    onChange={this.handleReceptionCommentChange}
                    commentFormRequired={true}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onApproval={this.handleApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegate'}
                    delegateComponent={<NatAdminApplicationApprovalDirectorDelegateComponent
                        onChange={this.onChangeActingChecked}/>}
                    rejectionButtonDisabled={this.state.actingChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalClick}
                    onRejection={this.handleDelegateRejectionClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApproval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onApproval={this.handleDelegateApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

NatAdminParkingUsesPageChange.contextType = AppAdminContext
export default createAdminPage(NatAdminParkingUsesPageChange)
